import { registerFunctionalComponent } from 'js/lib/components/component'

registerFunctionalComponent('.js-c-pages-admin-adoption-stories-dashboard', 'AdoptionStoriesDashboard', AdoptionStoriesDashboard)

function AdoptionStoriesDashboard(component) {
  const selectAllCheckbox = component.element.querySelector('.js-select-all-checkbox')
  
  if (!selectAllCheckbox) return

  component.useHandler(() => {
    const selectAllButton = selectAllCheckbox.querySelector('.js-c-form-input-checkbox__button')
    if (!selectAllButton) return

    selectAllButton.addEventListener('click', handleSelectAllToggle)
    
    // Add listeners for individual checkbox changes to update select-all state
    const bulkForm = component.element.querySelector('#bulk-adoption-story-update')
    if (bulkForm) {
      const rowCheckboxWrappers = bulkForm.querySelectorAll('.js-c-form-input-checkbox')
      const rowCheckboxListeners = []
      
      rowCheckboxWrappers.forEach(wrapper => {
        const inputElement = wrapper.querySelector('.js-c-form-input-checkbox__input')
        if (inputElement && inputElement.name && inputElement.name.match(/^adoption_story\[\d+\]$/)) {
          const button = wrapper.querySelector('.js-c-form-input-checkbox__button')
          if (button) {
            const listener = () => setTimeout(updateSelectAllState, 10) // Small delay to ensure checkbox state is updated
            button.addEventListener('click', listener)
            rowCheckboxListeners.push({ button, listener })
          }
        }
      })
      
      // Initial select-all state check
      updateSelectAllState()

      return () => {
        selectAllButton.removeEventListener('click', handleSelectAllToggle)
        rowCheckboxListeners.forEach(({ button, listener }) => {
          button.removeEventListener('click', listener)
        })
      }
    }

    return () => selectAllButton.removeEventListener('click', handleSelectAllToggle)
  })

  function handleSelectAllToggle() {
    // Get the select all checkbox instance
    const selectAllInstance = selectAllCheckbox._componentInstance
    if (!selectAllInstance) return

    const isSelectAllChecked = selectAllInstance.isChecked()
    
    // Find all row checkbox wrapper elements inside the form
    const bulkForm = component.element.querySelector('#bulk-adoption-story-update')
    console.log('Bulk form:', bulkForm)
    if (!bulkForm) return
    
    const rowCheckboxWrappers = bulkForm.querySelectorAll('.js-c-form-input-checkbox')
    
    rowCheckboxWrappers.forEach(wrapper => {
      // Check if this wrapper contains a row checkbox by looking at the name attribute
      const inputElement = wrapper.querySelector('.js-c-form-input-checkbox__input')
      
      if (inputElement && inputElement.name && inputElement.name.match(/^adoption_story\[\d+\]$/)) {
        // Get the row checkbox instance
        const rowInstance = wrapper._componentInstance
        if (!rowInstance) return

        const isRowChecked = rowInstance.isChecked()
        
        // Only toggle if the current state doesn't match what we want
        if (isSelectAllChecked && !isRowChecked) {
          rowInstance.check()
        } else if (!isSelectAllChecked && isRowChecked) {
          rowInstance.uncheck()
        }
      }
    })
    
    // Update bulk action buttons after toggling all checkboxes
    setTimeout(() => updateBulkActionButtons(isSelectAllChecked), 10)
  }
  
  function updateSelectAllState() {
    const selectAllInstance = selectAllCheckbox._componentInstance
    if (!selectAllInstance) return
    
    // Find all row checkboxes inside the form
    const bulkForm = component.element.querySelector('#bulk-adoption-story-update')
    if (!bulkForm) return
    
    const rowCheckboxWrappers = bulkForm.querySelectorAll('.js-c-form-input-checkbox')
    let totalRows = 0
    let checkedRows = 0
    
    rowCheckboxWrappers.forEach(wrapper => {
      const inputElement = wrapper.querySelector('.js-c-form-input-checkbox__input')
      if (inputElement && inputElement.name && inputElement.name.match(/^adoption_story\[\d+\]$/)) {
        totalRows++
        const rowInstance = wrapper._componentInstance
        if (rowInstance && rowInstance.isChecked()) {
          checkedRows++
        }
      }
    })
    
    // Update select-all state based on row states
    if (checkedRows === 0) {
      selectAllInstance.uncheck()
    } else if (checkedRows === totalRows) {
      selectAllInstance.check()
    }
    // If partially checked, leave select-all in its current state
    
    // Enable/disable bulk action buttons based on selection
    updateBulkActionButtons(checkedRows > 0)
  }
  
  function updateBulkActionButtons(hasSelection) {
    const currentStatus = component.element.dataset.currentStatus
    const bulkActionButtons = component.element.querySelectorAll('.js-bulk-action-btn')
    console.log('updateBulkActionButtons called:', { hasSelection, currentStatus, buttonCount: bulkActionButtons.length })
    bulkActionButtons.forEach(button => {
      const buttonStatus = button.dataset.status
      // Keep disabled if no selection OR if button's action matches current status
      const shouldDisable = !hasSelection || buttonStatus === currentStatus
      console.log('Button:', { buttonStatus, shouldDisable, currentStatus })
      button.disabled = shouldDisable
    })
  }
}
